export interface UserFromAPI {
  id: string;
  firstName: string;
  lastName: string;
  email: string;
  globalRoles: GlobalRole[];
  isSuperAdmin?: boolean;
  active?: boolean;
}

export type GlobalRole = {
  id: string;
  name: string;
};

// enum for assigning colors in User table
export enum GlobalUserRoles {
  support = "role-support",
  accountManager = "role-account-manager",
}
